import { flow, get, reduce } from 'lodash/fp'
import { Journey, PageQuestionsItem } from '../../types'

const getQuestions = (questions: PageQuestionsItem[], page: any): PageQuestionsItem[] => [
  ...questions,
  ...page.pageQuestions,
]

const getInitialValues = (initialValues: any, question: PageQuestionsItem) => {
  const { assumedValue, canBeAssumed, currentAnswerValue, questionParameterName } = question

  if (currentAnswerValue) {
    return {
      ...initialValues,
      [questionParameterName]: currentAnswerValue,
    }
  }

  if (canBeAssumed) {
    return {
      ...initialValues,
      [questionParameterName]: assumedValue,
    }
  }

  return initialValues
}

export default (journey: Journey) =>
  flow(get('journeyPages'), reduce(getQuestions, []), reduce(getInitialValues, {}))(journey)
